import React from "react";
import PersonCard from "../components/PersonCard";

const PeopleSearchResult: React.FC<JQI.PeopleSearchResultProps> = (props) => {
  const { filters, ...otherProps } = props;

  return <PersonCard {...otherProps} />;
}

export default PeopleSearchResult;